// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "media/media" + ".css?v=" + "86b13efdc59f5762536b" + "";
};